<template>
  <div>
    <vc-calendar
      ref="calendar"
      is-expanded
      :masks="masks"
      :firstDayOfWeek="1"
      @dayclick="onDayClick"
      @update:from-page="onFromPage"
      @update:to-page="onToPage"
      :attributes="attrs"
      :v-model="currentDate"
      timezone="Asia/Pyongyang"
      locale="ja"
    ></vc-calendar>
    <div class="calnews">
      <ul>
        <!-- schedule roop start -->

        <li v-for="(item, index) in news" :key="index">
          <a
            :href="item.url"
            v-if="item.url != ''"
            :target="item.url_target ? '_blank' : ''"
          >
            <div class="date">
              {{ dispDate(item) }}
            </div>
            <span v-html="createTag(item.label)"></span>
            <div class="text">{{ item.calender_text }}</div>
          </a>
          <div v-else>
            <router-link
              v-if="item.type == 'normal'"
              :to="{
                name: 'information-detail',
                params: {
                  id: item._id,
                  mc_code: currentUser.mansion._id,
                },
              }"
            >
              <div class="date">
                {{ dispDate(item) }}
              </div>
              <span v-html="createTag(item.label)"></span>
              <div class="text">{{ item.calender_text }}</div>
            </router-link>
            <router-link
              v-else-if="item.type == 'global'"
              :to="{
                name: 'global-information-detail',
                params: {
                  id: item._id,
                  mc_code: currentUser.mansion._id,
                },
              }"
            >
              <div class="date">
                {{ dispDate(item) }}
              </div>
              <span v-html="createTag(item.label)"></span>
              <div class="text">{{ item.calender_text }}</div>
            </router-link>
            <router-link
              v-else
              :to="{
                name: 'bod-information-detail',
                params: {
                  id: item._id,
                  mc_code: currentUser.mansion._id,
                },
              }"
            >
              <div class="date">
                {{ dispDate(item) }}
              </div>
              <span v-html="createTag(item.label)"></span>
              <div class="text">{{ item.calender_text }}</div>
            </router-link>
          </div>
        </li>
        <!-- schedule roop end -->
      </ul>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import InfoService from "@/services/info.service";
import BoDInfoService from "@/services/bod-info.service";
import GlobalInfoService from "@/services/global-info.service";

export default {
  name: "Header",
  props: {
    roomNo: String,
  },
  data() {
    return {
      currentMonth: { year: 0, month: 0 },
      news: [],
      masks: {
        title: "YYYY MM",
        weekdays: "W",
        navMonths: "MMM",
        input: ["L", "YYYY-MM-DD", "YYYY/MM/DD"],
        dayPopover: "WWW, MMM D, YYYY",
        data: ["L", "YYYY-MM-DD", "YYYY/MM/DD"],
      },
      attrs: [
        {
          key: "today",
          highlight: {
            color: "orange",
            fillMode: "light",
          },
          dates: new Date(),
        },
        {
          key: "schedule",
          dot: true,
          dates: new Date(),
          customData: { _id: "abc" },
        },
        {
          key: "schedule",
          highlight: {
            start: { fillMode: "outline" },
            base: { fillMode: "light" },
            end: { fillMode: "outline" },
          },
          dates: { start: new Date(2021, 5, 14), end: new Date(2021, 5, 20) },
          customData: { _id: "qwe" },
        },
        {
          key: "schedule2",
          highlight: {
            start: { fillMode: "outline" },
            base: { fillMode: "light" },
            end: { fillMode: "outline" },
          },
          dates: { start: new Date(2021, 5, 16), end: new Date(2021, 5, 25) },
          customData: { _id: "asd" },
        },
      ],
    };
  },
  methods: {
    dispDate(obj) {
      let startDate, endDate, startTime;
      let endTime = moment(obj.calender_range.end).format("HH:mm");
      if (obj.type == "global") {
        startDate = moment(obj.calender_range[0]).format("MM.DD");
        endDate = moment(obj.calender_range[1]).format("MM.DD");
        startTime = moment(obj.calender_range[0]).format("HH:mm");
        endTime = moment(obj.calender_range[1]).format("HH:mm");
      } else {
        startDate = moment(obj.calender_range.start).format("MM.DD");
        endDate = moment(obj.calender_range.end).format("MM.DD");
        startTime = moment(obj.calender_range.start).format("HH:mm");
        endTime = moment(obj.calender_range.end).format("HH:mm");
      }

      let result = "";
      if (obj.is_dispTime) {
        if (startDate != endDate) {
          result = `${startDate} ${startTime} 〜 ${endDate} ${endTime}`;
        } else if (startTime != endTime) {
          result = `${startDate} ${startTime} 〜 ${endTime}`;
        } else {
          result = `${startDate} ${startTime} 〜`;
        }
      } else {
        if (startDate != endDate) {
          result = `${startDate} 〜 ${endDate}`;
        } else {
          result = `${startDate}`;
        }
      }

      return result;
    },
    onDayClick() {
      //
    },
    onFromPage() {
      //
    },
    onToPage: async function(obj) {
      this.currentMonth = obj;
      //
      obj.is_schedule = true;
      obj.limit = 100;
      const response = await InfoService.list(obj);

      this.news = [];
      if (response.data.docs != undefined) {
        const docs1 = response.data.docs;

        for (let index = 0; index < docs1.length; index++) {
          const element = docs1[index];
          element.type = "normal";
          this.news.push(element);
        }
      }

      const response2 = await BoDInfoService.list(obj);
      //
      if (response2.data.docs != undefined) {
        const docs2 = response2.data.docs;

        for (let index = 0; index < docs2.length; index++) {
          const element = docs2[index];
          element.type = "bod";
          this.news.push(element);
        }
      }

      const responseGlobal = await GlobalInfoService.findCalender(obj);

      if (responseGlobal.length > 0) {
        for (let index = 0; index < responseGlobal.length; index++) {
          const element = responseGlobal[index];
          element.type = "global";
          this.news.push(element);
        }
      }

      this.news = Array.from(
        new Map(this.news.map(item => [item._id, item])).values(),
      );

      //

      this.attrs = [];

      for (let index = 0; index < this.news.length; index++) {
        const element = this.news[index];
        if (element.type == "global") {
          this.attrs.push({
            key: element._id,
            highlight: {
              start: { fillMode: "outline" },
              base: { fillMode: "light" },
              end: { fillMode: "outline" },
            },
            dates: {
              start: element.calender_range[0],
              end: element.calender_range[1],
            },
          });
        } else {
          this.attrs.push({
            key: element._id,
            highlight: {
              start: { fillMode: "outline" },
              base: { fillMode: "light" },
              end: { fillMode: "outline" },
            },
            dates: {
              start: element.calender_range.start,
              end: element.calender_range.end,
            },
          });
        }
      }

      this.attrs.push({
        key: "today",
        highlight: {
          color: "orange",
          fillMode: "light",
        },
        dates: new Date(),
      });
    },
  },
};
</script>

<style scoped></style>
